import _ from "lodash";
import Errors from "../../../utils/Errors";
const {setFieldVisibility} = require("../../../../apps/KpModule/actions");
const {getFormValues} = require("../../../../apps/KpModule/selectors");

// Seul un produit sur mesure (ex. CNDA) est rattaché à un client
const isCustom = product => _.get(product, 'kind.id') === 'custom'

export const entity = {
    name: 'Product',
    facets: [{name: 'codeName', uniqueName: true}, 'conversations'],
    fields: [
        {path: 'kind', type: 'ProductKind'},
        {path: 'client', type: 'GroupAndCompany', nullable: true},
        {path: 'owner', type: 'User', nullable: true},
        'description',
        {path: 'state', type: 'Status'}
    ],
    filters: [
        {
            name: 'byState',
            path: 'state',
            object: 'Status',
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const state = _.get(context, 'data.state.id');
                return state ? {state} : {};
            }
        },
        {
            name: 'onlySolutions',
            isDefault: false,
            query: function() {
                return {kind: 'solution'}
            }
        }
    ],
    beforeSave: function(newObject, oldObject, context, callback) {
        if (isCustom(newObject) && !newObject.client) {
            return callback(new Errors.ValidationError(context.tc('customProductRequiresClient')))
        }
        if (!isCustom(newObject)) newObject.client = null

        callback(null, newObject, oldObject)
    }
}

export const module_ = {
    object: 'Product',
    category: {
        path: 'catalog',
        icon: 'package'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'code',
            'name',
            'kind',
            {path: 'client', display: 'fullName'},
            {path: 'owner', initiallyNotVisible: true},
            {path: 'state', initiallyNotVisible: true}
        ],
        form: {
            fields: [
                {path: 'code', placeholder: 'renseigner un code unique', noSpaces: true},
                {path: 'name', placeholder: 'renseigner un nom unique'},
                {
                    path: 'kind',
                    placeholder: 'sélectionner le type de produit',
                    subscriptions: {
                        onChange: (newValue, oldValue, {store}) => {
                            store.dispatch(setFieldVisibility('e_client', _.get(newValue, 'id') === 'custom'))
                        }
                    }
                },
                {path: 'client', display: 'fullName', placeholder: 'sélectionner le client du produit sur mesure'},
                {path: 'owner', placeholder: 'sélectionner le responsable du produit'},
                {path: 'description', tKey: 'synthèse', type: 'richTextEditor'},
                {path: 'conversations', tKey: 'suivi'},
                {path: 'state', type: 'toggle', default: {id: 'actif'}}
            ],
            onOpen: ({state, store}) => {
                store.dispatch(setFieldVisibility('e_client', isCustom(getFormValues(state))))
            }
        }
    },
    filters: [
        {
            path: 'kind',
            object: 'ProductKind',
            display: 'name',
            client: true,
            clearable: true,
            default: {id: null},
            query: function(context) {
                const kindId = _.get(context.data, 'kind.id')
                return kindId ? {kind: kindId} : {}
            }
        },
        'byState'
    ]
}
